module.exports = __webpack_public_path__ + "static/media/jerry.fb2287ad.png";